import { bilhetagemService } from '../service/';

let bilhetagens = []

const BilhetagemController = {

  clean: () => bilhetagens = [],

  getAll: () => bilhetagens,

  add: bilhetagem => {
    bilhetagens = bilhetagens
      .filter(b => String(b.telefone || '').replace(/\D/ig, '') !== String(bilhetagem.telefone || '').replace(/\D/ig, ''))

    bilhetagens.push(bilhetagem)
  },

  save() {
    bilhetagens
      .filter(bilhetagem => bilhetagem.telefone)
      .forEach(bilhetagem => {
        bilhetagemService.save(bilhetagem)
      })

    this.clean()
  },
}

export default BilhetagemController



// WEBPACK FOOTER //
// ./src/controllers/BilhetagemController.js